<template>
  <Error :text="notification.text"></Error>
</template>

<script>
// @ is an alias to /src
import Error from "@/components/Error.vue";

export default {
  name: "NotFound",
  components: {
    Error
  },
  data () {
    return {
      notification: {
        text: this.$t("ErrorNotFound")
      }
    }
  }
};
</script>
